import { render, staticRenderFns } from "./claimAgent.vue?vue&type=template&id=51ea3951&scoped=true&"
import script from "./claimAgent.vue?vue&type=script&lang=js&"
export * from "./claimAgent.vue?vue&type=script&lang=js&"
import style0 from "./claimAgent.vue?vue&type=style&index=0&id=51ea3951&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ea3951",
  null
  
)

export default component.exports